import { Promise } from 'bluebird'
import { first } from 'lodash'
import printJS from 'print-js'
import unitUtil from '../utils/unit.util'
import { Markup } from '../views/LabelBuilder/LabelBuilder.slice'
import markupService from './markup.service'

export default {
  print (uri: string) {
    printJS({ printable: uri, type: 'pdf', base64: true })
  },

  printElement (element: HTMLElement, inchWidth: number, inchHeight: number) {
    document.documentElement.appendChild(element)
    const width = `${inchWidth}in`
    const height = `${inchHeight}in`
    const styleElement = document.createElement('style')
    styleElement.textContent = `
      @media print {
        @page {
          size: ${width} ${height};
          margin: 0;
        }
      }
    `
    document.head.appendChild(styleElement)
    setTimeout(() => {
      window.print()
      element.remove()
      styleElement.remove()
    }, 100)
  },

  async printMarkups (markups: Markup[]) {
    const printElement = document.createElement('div')
    const firstMarkup = first(markups)
    if (!firstMarkup) return
    await Promise.each(markups, async (markup, index) => {
      const labelElement = document.createElement('div')
      labelElement.style.breakBefore = index === 0 ? 'auto ' : 'page'
      const imageElement = await markupService.toImageElement(markup)
      if (!imageElement) return
      imageElement.style.width = 'calc(100% - 1px)'
      imageElement.style.height = 'calc(100% - 1px)'
      labelElement.appendChild(imageElement)
      printElement.appendChild(labelElement)
    })
    const inchWidth = unitUtil.unitToInch(firstMarkup.stage.unit, firstMarkup.stage.width)
    const inchHeight = unitUtil.unitToInch(firstMarkup.stage.unit, firstMarkup.stage.height)
    this.printElement(printElement, inchWidth, inchHeight)
  }
}
